import { RootState } from "~/store/rootReducer";

export const selectLettersData = (state: RootState) => state.assets.Letters;
export const selectElementsData = (state: RootState) => state.assets.Elements;
